import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { USERS_CONFIG } from '@config/users.config';
import { CookiesService } from './cookies.service';
import { Config } from '@config/config.service';
import { ROLES_CONFIG, ROLES_ID_CONFIG } from '@config/roles.config';
import { UserApiService } from '@services/remote-api';

@Injectable()
export class AccountService {
  profileData: any;
  companyUsers: any;

  constructor(
    private cookiesService: CookiesService,
    private config: Config,
    private userApiService: UserApiService
  ) { }

  getCompanyProfiles(): Observable<any> {
    if (this.companyUsers) {
      return of(this.companyUsers);
    }
    return this.userApiService.getCompanyProfiles().pipe(
      tap((response: any) => {
        this.companyUsers = response;
      })
    );
  }


  getCompanyOfferProfiles(offerId: string): Observable<any> {
    return this.userApiService.getCompanyOfferProfiles(offerId);
  }

  setProfileData(): any {
    const jwtData = this.parseJwt(
      this.cookiesService.getCookie(this.config.accessTokenKey)
    );

    this.profileData = {
      userId: jwtData.company,
      roleId: ROLES_ID_CONFIG[jwtData.auth],
      role: ROLES_CONFIG[ROLES_ID_CONFIG[jwtData.auth]],
      user: USERS_CONFIG[jwtData.company]
    };
  }

  isSuperAdmin() {
    return this.profileData.roleId === ROLES_ID_CONFIG.ROLE_SUPER_ADMIN;
  }

  getUser(): any {
    return this.profileData && this.profileData.user ? this.profileData.user : USERS_CONFIG['guest'];
  }

  getRole(): any {
    return this.profileData && this.profileData.role ? this.profileData.role : ROLES_CONFIG[ROLES_ID_CONFIG.ROLE_GUEST];
  }

  private parseJwt(token): any {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  }
}
